import React from 'react'
import Select from 'meinian-package/src/baseComponent/select'

export default (props) => {
  const { data, onChange, value, displayStyle } = props
  return <Select
    placement="bottomRight"
    displayStyle={displayStyle}
    data={data}
    value={value}
    onChange={onChange}
    placeholder="不限"
  />
}
